import { SubmissionError } from 'redux-form/immutable';
import { changePassword } from '../../../services/API';

export default async function (vals, dispatch, props) {
  const values = vals.toJS();
  validate(values);

  const data = await changePassword({ ...values, token: props.token });
  return validateResponse(data);
}

async function validateResponse(response) {
  if (!response.isOk) {
    throw new SubmissionError(response.error.response.data);
  }
}

function validate(values) {
  const requiredMessage = 'Это поле не может быть пустым';
  const passwordNotEqualsMessage = 'Пароли не сопадают';
  const error = {};

  if (!values.newPassword1) {
    error.newPassword1 = requiredMessage;
  }

  if (!values.newPassword2) {
    error.newPassword2 = requiredMessage;
  }

  if (values.newPassword1 !== values.newPassword2) {
    error.newPassword1 = passwordNotEqualsMessage;
  }

  if (Object.keys(error).length > 0) {
    throw new SubmissionError(error);
  }
}
